import React, { FC } from 'react';
import { ArrowRight } from '../icon';
import { LinkLabel } from '../linkLabel';
import { Spacer } from '../spacer';

// Interface

export interface LinkListProps {
  links: LinkListItemProps[];
}

export interface LinkListItemProps {
  url: string;
  label: string;
}

// JSX

export const LinkList: FC<LinkListProps> = ({ links, variant, ...rest }) => {
  if (!links || links.length <= 0) {
    return null;
  }

  return (
    <Spacer as="ul" spacing="small" {...rest}>
      {links?.length >= 1 &&
        links.map(({ url, label }, index) => (
          <li>
            <LinkLabel
              url={url}
              label={label}
              key={index}
              iconLeft={<ArrowRight />}
            />
          </li>
        ))}
    </Spacer>
  );
};

export default LinkList;
